// React polyfills, see https://reactjs.org/docs/javascript-environment-requirements.html
import "core-js/es6/map";
import "core-js/es6/set";
import "raf/polyfill";
// Other polyfills
import "core-js/fn/array/includes";
import "core-js/fn/promise";
import "fetch-ie8";

import renderTopicList from "./topic-list/";
import { trigger as hotJarTrigger } from "./helpers/hotjar";

renderTopicList(document.getElementById("topic-list-root"), () => {
	hotJarTrigger("topic-list");
});
